module.exports = __webpack_public_path__ + "static/media/ListFile.b370797d.txt";